import * as React from 'react';

import {BulletedList} from '../../../bulleted-list/bulleted-list';
import {SelectPickerGeneric} from '../../../select-picker-generic/select-picker-generic';
import {SelectPickerGenericMulti} from '../../../select-picker-generic/select-picker-generic-multi';
import {Body} from '../../../typography/body';

import type {CustomFieldEnumOption} from '../helpers';

type Props = {
    value: string[] | null | undefined;
    allowMultiple: boolean;
    onUpdateValue: (value?: string[] | null | undefined) => void;
    options: CustomFieldEnumOption[];
    placeholder?: string;
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
};

export function DecisionCustomField(props: Props) {
    const handleChange = (value: any) => {
        let selectedValue;
        if (props.allowMultiple) {
            // @ts-expect-error
            selectedValue = value ? value.map((option) => option.value) : [];
        } else {
            selectedValue = value ? [value.value] : null;
        }
        props.onUpdateValue(selectedValue);
        props.setIsEditing(false);
    };

    const handleClear = () => {
        props.onUpdateValue(null);
        props.setIsEditing(false);
    };

    if (props.allowMultiple) {
        return (
            <div onBlur={() => props.setIsEditing(false)}>
                {props.isEditing ? (
                    <div onClick={(e) => e.stopPropagation()}>
                        <SelectPickerGenericMulti
                            value={props.options.filter(
                                (option) => props.value && props.value.includes(option.value)
                            )}
                            autoFocus={true}
                            onChange={handleChange}
                            onClear={handleClear}
                            options={props.options}
                            placeholder={props.placeholder}
                            isMulti={true}
                            isSmall={true}
                            openMenuOnFocus={true}
                            closeMenuOnSelect={false}
                            menuZIndex={11}
                        />
                    </div>
                ) : (
                    <>
                        {props.value && props.value.length > 0 ? (
                            <BulletedList
                                bullets={props.value.map((val) => {
                                    const option = props.options.find((opt) => opt.value === val);

                                    return option ? option.label : val;
                                })}
                                size='small'
                                greyBullets={true}
                                marginBottom={0}
                                lessSpacing={true}
                            />
                        ) : (
                            <Body size='small' color='light' wrapAnywhere={true}>
                                {props.placeholder || 'Select'}
                            </Body>
                        )}
                    </>
                )}
            </div>
        );
    }

    return props.isEditing ? (
        <div onClick={(e) => e.stopPropagation()}>
            <SelectPickerGeneric
                value={props.options.find(
                    (option) => option.value === (props.value && props.value[0])
                )}
                onChange={handleChange}
                autoFocus={true}
                options={props.options}
                placeholder={props.placeholder}
                onClear={handleClear}
                onMenuClose={() => props.setIsEditing(false)}
                hideDividerWhenEmpty={true}
                openMenuOnFocus={true}
                menuZIndex={11}
            />
        </div>
    ) : (
        <Body size='small' color={props.value ? 'medium' : 'light'} wrapAnywhere={true}>
            {!props.value ? props.placeholder : props.value[0]}
        </Body>
    );
}
